import React from 'react';
import { Box, HomeButton, Stack, Typography } from 'styles';
import { theme } from 'styles/theme/ThemeStyle';
import { useMediaQuery } from 'stylesHooks';
import { TRANSLATION_KEYS } from 'utils/constants';
import { Dashboard_Sections } from 'utils/links';
import { useTranslation } from 'utils/translations';

const DashboardMenu: React.FC = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const tablet = useMediaQuery(theme.breakpoints.down('lg'));

	const sections = Dashboard_Sections(tClientLabels, true);
	const gapValue = !!tablet ? 1.87 : 1.9;
	const itemsPerColumn = 3;
	const actualSections = sections.filter(e => !!e.show);

	return (
		<Stack direction={'row'} gap={!!tablet ? '18px' : '40px'} width="100%">
			<Stack width={'100%'} gap={'20px'}>
				<Typography variant="title6" sx={{ mb: 0.5, pl: 2 }}>
					{tClientLabels('dashboard.actions')}
				</Typography>
				<Box
					sx={{
						display: 'grid',
						gridAutoFlow: 'column',
						gridTemplateRows: `repeat(${itemsPerColumn}, auto)`,
						gridAutoColumns: 'minmax(0, 1fr)',
						gap: theme.spacing(gapValue),
						width: '100%',
					}}
				>
					{actualSections.map(e => (
						<HomeButton
							startIcon={e.icon}
							label={e.name}
							to={e.link}
							disabled={!e.show}
							key={e.id}
						/>
					))}
				</Box>
			</Stack>
		</Stack>
	);
};

export default DashboardMenu;
